export enum LocationRoles {
  CCCStaff = 1,
  Checkout = 2,
  Washer = 3,
  ReturnStation = 4,
}
